module.exports = __webpack_public_path__ + "media/icons/checkbox-red-unchecked-27859440.svg";